import { useEffect, useState } from 'react';
import orderBy from 'lodash/orderBy';

export default function useSortable(results, initialSortObject) {
    const [sortObject, setSort] = useState(initialSortObject);
    const [sortedResults, setSortedResults] = useState(results);

    useEffect(() => {
        if (!sortObject) {
            setSortedResults(results);
        } else {
            const sorted = orderBy(
                results,
                (result) => {
                    if (typeof result[sortObject.columnName] === 'string') {
                        return result[sortObject.columnName].toLowerCase();
                    }

                    return result[sortObject.columnName];
                },
                sortObject.sortOrder
            );

            setSortedResults(sorted);
        }
    }, [results, sortObject]);

    return [sortObject, setSort, sortedResults];
}
